<template>
    <div>
      <div class="group-detail">
        <div class="content-wrapper">
          <div class="main-content">
            <div class="main-content__csv-box">
              <p>Booth Assignment csv</p>
              <FileInput v-model="boothAssignmentCsv" @changedFile="errors = null" />
            </div>
            <div class="main-content__msg-box">
              <ErrorCsv :errorMessages="errors" />
            </div>
          </div>
          <div class="button-container">
            <div
              @click="confirmUploadCsv(false)"
              class="import-button"
            >
              Import
            </div>
            <div
              @click="confirmUploadCsv(true)"
              class="skip-button"
            >
              Skip
            </div>
          </div>
        </div>
      </div>

      <Loading :isLoading="isImporting" />
    </div>
  </template>

<script lang="ts">
import _ from 'lodash'
import FileInput from '@/components/parts/inputItem/FileInput.vue'
import ErrorCsv from '@/components/parts/ErrorCsv.vue';
import { countRecords, readCsv } from '@/utils/csv'
import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator'
import { AssignmentStatus } from '@/store/groups/formation/types';
import Loading from '@/components/parts/modal/Loading.vue';
//@ts-expect-error 型チェック不要部分
import FileSaver from 'file-saver';

@Component({
  components: {
    FileInput,
    ErrorCsv,
    Loading,
  },
})

export default class AssignBoothEdit extends Vue {
  @Prop({ required: true }) selectedAssignment!: AssignmentStatus

  boothAssignmentCsv: File|null = null

  errors: string|null = null

  isImporting: boolean = false

  warnings: string[] = []

  async confirmUploadCsv(skip: any) {
    if (this.isImporting) return
    if (skip) {
      if (_.isNull(this.selectedAssignment)) {
        throw Error('ブースアサイン時の年度学期が選択されていません')
      }
      this.isImporting = true

      this.$store.dispatch('importAssignBoothSkip', {
        assignment: this.selectedAssignment,
      })
        .then(() => {
          this.$bvModal.msgBoxOk('Success !')
            .then(() => this.$emit('complete'))
        })
        .catch((error) => {
          this.errors = error
        })
        .finally(() => { this.isImporting = false })
    } else {
      this.errors = null
      if (!this.boothAssignmentCsv) {
        this.errors = 'Please select Booth Assignment csv.'
        return
      }

      try {
        const reader = await readCsv(this.boothAssignmentCsv)
        const count = countRecords(reader)
        const isOk = await this.$bvModal.msgBoxConfirm('Assign booths Edit. Is it OK?', {
          centered: true,
        })

        if (isOk === true) {
          this.importBooth()
        }
      } catch (error) {
        this.errors = 'Selected csv file has error. please select file again.'
        this.boothAssignmentCsv = null
      }
    }
  }

  importBooth() {
    if (_.isNull(this.selectedAssignment)) {
      throw Error('ブースアサイン時の年度学期が選択されていません')
    }
    this.isImporting = true

    this.$store.dispatch('importBoothByCsv', {
      assignment: this.selectedAssignment,
      boothAssignmentCsv: this.boothAssignmentCsv,
    })
      .then(() => {
        this.$bvModal.msgBoxOk('Success !')
          .then(() => this.$emit('complete'))
      })
      .catch((error) => {
        this.errors = error
      })
      .finally(() => { this.isImporting = false })
  }

  checkError(error: string) {
    this.errors = error
  }
}

</script>

<style scoped>
h1 {
  text-align: center;
  margin-bottom:20px;
}

select {
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 100%;
}

.sub-title {
  padding:10px;
  margin-bottom: 20px;
  background: #DDEAF6;
  display: flex;
  align-items: center;
}

.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
  min-height: 500px;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 20px;
}

.button-container {
  display: flex;
  justify-content: center;
}

.import-button {
  margin-left:10px;
  display: block;
  text-decoration: none;
  color: #ffffff;
  min-width: 120px;
  font-size:15px;
  line-height: 15px;
  text-align: center;
  padding: 10px;
  border: 3px solid #1cc8a0;
  border-radius: 20px;
  cursor: pointer;
  transition: .2s;
  user-select:none;
  background: #1cc8a0;
}

.import-button:hover {
  background: #fff;
  color: #1cc8a0;
}

.skip-button {
  margin-left:10px;
  display: block;
  text-decoration: none;
  color: #1cc8a0;
  min-width: 120px;
  font-size:15px;
  line-height: 15px;
  text-align: center;
  padding: 10px;
  border: 3px solid #ffffff;
  border-radius: 20px;
  cursor: pointer;
  transition: .2s;
  user-select:none;
  background: #ffffff;
}

.skip-button:hover {
  background: #1cc8a0;
  color: #fff;
}

.main-content p {
  display: block;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
  text-align: left;
  margin:10px 0;
  font-weight: bold;
}

.main-content__csv-box {
  margin-bottom:70px;
  padding-right: 30px;
  padding-left: 30px;
}

.main-content__download-button {
  margin-top:2px;
  padding-right: 30px;
  padding-left: 30px;
}
</style>
